import React from 'react';
import { AutocompleteRenderGroupParams } from '@material-ui/lab/Autocomplete';

interface AutocompleteRenderGroupProps {
  params: AutocompleteRenderGroupParams;
  groupLabelClassName: string;
  groupListClassName: string;
  renderGroup?: (group: string) => React.ReactNode;
}

export const AutocompleteRenderGroup: React.FC<AutocompleteRenderGroupProps> = ({
  params,
  groupLabelClassName,
  groupListClassName,
  renderGroup,
}) => {
  const { group, children, key } = params;

  return (
    <div key={key}>
      <div className={groupLabelClassName}>{renderGroup?.(group) ?? group}</div>
      <div className={groupListClassName}>
        {children}
      </div>
    </div>
  );
};

